const SvgAwardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.667"
      d="M7.398 10.913l-3.48-4.35c-.216-.27-.325-.405-.402-.556a1.667 1.667 0 01-.148-.423c-.034-.166-.034-.34-.034-.686v-.565c0-.933 0-1.4.182-1.756.16-.314.414-.569.728-.729.357-.181.823-.181 1.757-.181h8c.933 0 1.4 0 1.756.181.314.16.569.415.729.729.181.356.181.823.181 1.756v.565c0 .347 0 .52-.034.686-.03.147-.08.29-.148.423-.077.15-.186.286-.402.557l-3.48 4.349M4.168 2.5l5.834 7.5 5.833-7.5m-2.887 8.72a4.167 4.167 0 11-5.892 5.893 4.167 4.167 0 015.892-5.893z"
    ></path>
  </svg>
)

export default SvgAwardIcon
